import React from "react";
import { ShieldCheck, Eye } from "lucide-react";

// Role visual identity — staff only. Seeker is intentionally unbadged.
export const ROLE_META = {
  oracle: { label: "Oracle", color: "#D8B66A", icon: ShieldCheck },
  watcher: { label: "Watcher", color: "#64B5F6", icon: Eye },
};

export const isStaffRole = (role) => role === "watcher" || role === "oracle";

export const RoleBadge = ({ role, className = "" }) => {
  const meta = ROLE_META[role];
  if (!meta) return null;
  const Icon = meta.icon;
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-[0.18em] ${className}`}
      style={{
        color: meta.color,
        border: `1px solid ${meta.color}55`,
        backgroundColor: `${meta.color}14`,
      }}
    >
      <Icon className="h-2.5 w-2.5" /> {meta.label}
    </span>
  );
};
